import TuneIcon from '@mui/icons-material/Tune';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const navItems = [
    {
      title: "Home",
      icon: <TuneIcon sx={{color:"white"}}/>,
      locationRef : "home",
      href: "/",
    },
    {
      title: "My Assessments", 
      icon: <SpaceDashboardOutlinedIcon sx={{color:"white"}}/>,
      openIcon: <KeyboardArrowUpIcon sx={{color:"white"}}/>,
      closeIcon: <KeyboardArrowDownIcon sx={{color:"white"}}/>,
      href: "",
      pages: [
        {
          title: "MIM Self-Assessment",
          locationRef : "mim_self_assessment",
          href:"/assessment/mim_self_assessment"
        },
        {
          title: "LIM Self-Assessment",
          locationRef : "lim_self_assessment",
          href:"/assessment/lim_self_assessment"
        },
        {
          title: "TIM - Team Assessment",
          locationRef : "tim_self_assessment",
          href:"/assessment/tim_self_assessment"
        },
        {
          title: "LIM 360-Assessment",
          locationRef : "lim_360_assessment",
          href:"/assessment/lim_360_assessment"
        },
        {
          title: "MIM 360-Assessment",
          locationRef : "mim_360_assessment",
          href:"/assessment/mim_360_assessment"
        },
      ],
    },
    {
      title: "Admins",
      locationRef : "users",
      icon: <PersonIcon sx={{color:"white"}}/>,
      href: "/users",
    },
    {
      title: "Email Templates",
      locationRef : "email_templates",
      icon: <EmailIcon sx={{color:"white"}}/>,
      href: "/email-templates",
    },
];